import { styled } from 'stitches.config'

export const HowItWorksRoot = styled('div', {
  position: 'relative',
  backgroundColor: '$accent-account-submenu',
  py: '$10',
  px: '$3',
  marginTop: '$11',
  color: '$primary-800',
  borderBottom: '9px solid transparent',
  borderTop: 0,
  borderImage: 'url(/assets/border-pattern.svg) 30',

  '@bp2': {
    px: '$15',
    marginTop: '$12',
  },
})

export const IsotypeContainer = styled('div', {
  position: 'absolute',
  top: 0,
  left: '50%',
  size: '$12',
  transform: 'translate(-50%, -50%)',
})

export const Steps = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '$3',
  margin: 'auto',
})

export const Wrapup = styled('div', {
  maxWidth: '636px',
  margin: '0 auto',
  textAlign: 'center',
  marginTop: '$7',
  py: '$2',
  px: '$4',
  border: 'none',
  borderTop: '1px solid $primary-800',
  borderBottom: '1px solid $primary-800',
})
